module.exports = __webpack_public_path__ + "static/media/tongyimenhu.2b9be65.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/tongyimenhu.mp4
// module id = T2dj
// module chunks = 0